/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  DataSeriesResponseDto,
  GetDataSeriesForTargetParams,
  GetSeriesForTargetParams,
  SeriesResponseDto
} from '../../model';





/**
 * Returns the series that can be selected for the diagram, grouped by series type. Each item has the same stable id as the corresponding data series and indicates whether data exists in the requested half-open time interval [fromTimeMicros, toTimeMicros).
 * @summary Get selectable diagram series for a target in JSON
 */
export const getSeriesForTarget = (
    targetId: number,
    params: GetSeriesForTargetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SeriesResponseDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/diagram/${targetId}/series`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetSeriesForTargetQueryKey = (targetId?: number,
    params?: GetSeriesForTargetParams,) => {
    return [
    `/api/v1.1/diagram/${targetId}/series`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSeriesForTargetQueryOptions = <TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeriesForTargetQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeriesForTarget>>> = ({ signal }) => getSeriesForTarget(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeriesForTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getSeriesForTarget>>>
export type GetSeriesForTargetQueryError = AxiosError<unknown>


export function useGetSeriesForTarget<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeriesForTarget>>,
          TError,
          Awaited<ReturnType<typeof getSeriesForTarget>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeriesForTarget<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSeriesForTarget>>,
          TError,
          Awaited<ReturnType<typeof getSeriesForTarget>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeriesForTarget<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get selectable diagram series for a target in JSON
 */

export function useGetSeriesForTarget<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeriesForTargetQueryOptions(targetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSeriesForTargetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSeriesForTargetQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeriesForTarget>>> = ({ signal }) => getSeriesForTarget(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSeriesForTargetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSeriesForTarget>>>
export type GetSeriesForTargetSuspenseQueryError = AxiosError<unknown>


export function useGetSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get selectable diagram series for a target in JSON
 */

export function useGetSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSeriesForTargetSuspenseQueryOptions(targetId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns ignition and speed series together with one series for each requested measure channel. Ignition uses the reserved sourceId -1 and speed uses the reserved sourceId 0. Each series has a stable id, value type, label, and optional unit. Series order is not part of the contract.
 * @summary Get diagram data for a target in JSON
 */
export const getDataSeriesForTarget = (
    targetId: number,
    params: GetDataSeriesForTargetParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DataSeriesResponseDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/diagram/${targetId}/dataseries`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetDataSeriesForTargetQueryKey = (targetId?: number,
    params?: GetDataSeriesForTargetParams,) => {
    return [
    `/api/v1.1/diagram/${targetId}/dataseries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDataSeriesForTargetQueryOptions = <TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataSeriesForTargetQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataSeriesForTarget>>> = ({ signal }) => getDataSeriesForTarget(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataSeriesForTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getDataSeriesForTarget>>>
export type GetDataSeriesForTargetQueryError = AxiosError<unknown>


export function useGetDataSeriesForTarget<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataSeriesForTarget>>,
          TError,
          Awaited<ReturnType<typeof getDataSeriesForTarget>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataSeriesForTarget<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataSeriesForTarget>>,
          TError,
          Awaited<ReturnType<typeof getDataSeriesForTarget>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataSeriesForTarget<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get diagram data for a target in JSON
 */

export function useGetDataSeriesForTarget<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataSeriesForTargetQueryOptions(targetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDataSeriesForTargetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataSeriesForTargetQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataSeriesForTarget>>> = ({ signal }) => getDataSeriesForTarget(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDataSeriesForTargetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDataSeriesForTarget>>>
export type GetDataSeriesForTargetSuspenseQueryError = AxiosError<unknown>


export function useGetDataSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDataSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get diagram data for a target in JSON
 */

export function useGetDataSeriesForTargetSuspense<TData = Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetDataSeriesForTargetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDataSeriesForTarget>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDataSeriesForTargetSuspenseQueryOptions(targetId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




